module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("popup_container", [["div",{"class":"popup-title-wrapper"},[["span",{"class":"icon-au_close-delete cross close"}]]],["div",{"class":"widgetContainer popup","id":"popup-widget-container"}]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/popup.tpl
// module id = 1169
// module chunks = 4